export default __webpack_public_path__ + "static/media/jablotron-logo.93544e5d.png";